import { BASE, getCsrfToken } from "./constants";

const URL = `${BASE}/onpremise`;

export const getOnpremise = async (): Promise<string | null> => {
  const res = await fetch(URL);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  return data.guid ?? null;
};

export class OnpremiseValidationError extends Error {}
export class OnpremiseDuplicateError extends Error {}

export const updateOnpremise = async (guid: string): Promise<void> => {
  const res = await fetch(URL, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": getCsrfToken(),
    },
    body: JSON.stringify({ guid }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => null);
    if (body?.code === "invalid_input") throw new OnpremiseValidationError();
    if (body?.code === "duplicate_key") throw new OnpremiseDuplicateError();
    throw new Error(`HTTP ${res.status}`);
  }
};

export const deleteOnpremise = async (): Promise<void> => {
  const res = await fetch(URL, {
    method: "DELETE",
    headers: { "X-CSRFToken": getCsrfToken() },
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
};
